import React, { FC } from 'react';

const IntroStarsConfetti: FC = () => {
  return (
    <svg viewBox="0 25 375 251" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_210_67405)">
        <path
          d="M31.69 8.7545L34.306 18.111L43.4978 21.2585L35.4068 26.6382L35.2557 36.3519L27.6376 30.322L18.3505 33.1777L21.7344 24.068L16.1476 16.1206L25.8554 16.5213L31.69 8.7545Z"
          fill="#FBE200"
        />
      </g>
      <g clipPath="url(#clip1_210_67405)">
        <path
          d="M16.5903 62.1228L13.1034 71.1908L18.5987 79.2032L8.8961 78.689L2.97604 86.3917L0.464047 77.0064L-8.6914 73.7532L-0.538404 68.465L-0.276153 58.7539L7.27295 64.8707L16.5903 62.1228Z"
          fill="#FBE200"
        />
      </g>
      <g clipPath="url(#clip2_210_67405)">
        <path
          d="M210.828 34.3569L203.284 28.2356L193.964 30.9824L197.455 21.9149L191.962 13.9022L201.664 14.4171L207.59 6.71727L210.096 16.1064L219.25 19.3601L211.098 24.6465L210.828 34.3569Z"
          fill="#FBE200"
        />
      </g>
      <g clipPath="url(#clip3_210_67405)">
        <path
          d="M375.544 22.0781L372.094 31.1602L377.622 39.1502L367.917 38.6754L362.029 46.402L359.479 37.0269L350.31 33.8109L358.441 28.4897L358.664 18.7777L366.238 24.8638L375.544 22.0781Z"
          fill="#FBE200"
        />
      </g>
      <g clipPath="url(#clip4_210_67405)">
        <path
          d="M346.422 120.517L354.732 125.55L363.588 121.556L361.369 131.015L367.905 138.202L358.224 139.017L353.405 147.455L349.64 138.496L340.128 136.523L347.481 130.173L346.422 120.517Z"
          fill="#FBE200"
        />
      </g>
      <g clipPath="url(#clip5_210_67405)">
        <path
          d="M351.378 193.672L358.9 187.524L358.098 177.842L366.271 183.097L375.23 179.341L372.76 188.737L379.1 196.101L369.398 196.653L364.357 204.957L360.832 195.903L351.378 193.672Z"
          fill="#2D2A26"
        />
      </g>
      <g clipPath="url(#clip6_210_67405)">
        <path
          d="M-5.12356 228.634L4.1623 225.777L7.07128 216.507L12.6582 224.457L22.3725 224.357L16.5414 232.128L19.636 241.338L10.4419 238.191L2.64154 243.981L2.79131 234.266L-5.12356 228.634Z"
          fill="#2D2A26"
        />
      </g>
      <g clipPath="url(#clip7_210_67405)">
        <path
          d="M114.051 19.5037L121.688 25.5088L130.964 22.6196L127.612 31.7395L133.228 39.6672L123.519 39.3009L117.712 47.0905L115.062 37.7409L105.859 34.6277L113.93 29.2171L114.051 19.5037Z"
          fill="#2D2A26"
        />
      </g>
      <g clipPath="url(#clip8_210_67405)">
        <path
          d="M295.338 17.4931L301.929 24.6301L311.546 23.2438L306.795 31.7192L311.086 40.4349L301.557 38.5383L294.591 45.3118L293.453 35.6608L284.858 31.1318L293.683 27.0653L295.338 17.4931Z"
          fill="#2D2A26"
        />
      </g>
      <g clipPath="url(#clip9_210_67405)">
        <path
          d="M12.4904 185.019L7.55651 176.65L-2.13553 175.972L4.30014 168.692L1.94853 159.266L10.8609 163.135L19.1015 157.987L18.1737 167.661L25.6162 173.904L16.1317 176.013L12.4904 185.019Z"
          fill="white"
        />
      </g>
      <g clipPath="url(#clip10_210_67405)">
        <path
          d="M376.687 68.2189L373.122 77.2564L378.547 85.3161L368.85 84.7178L362.863 92.3689L360.432 82.9621L351.306 79.6297L359.504 74.4123L359.851 64.704L367.346 70.886L376.687 68.2189Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_210_67405">
          <rect
            width="30"
            height="30"
            fill="white"
            transform="translate(49.5853 31.3334) rotate(154.152)"
          />
        </clipPath>
        <clipPath id="clip1_210_67405">
          <rect
            width="30"
            height="30"
            fill="white"
            transform="translate(17.4681 90.9199) rotate(-169.194)"
          />
        </clipPath>
        <clipPath id="clip2_210_67405">
          <rect
            width="30"
            height="30"
            fill="white"
            transform="translate(183.172 26.2823) rotate(-61.1725)"
          />
        </clipPath>
        <clipPath id="clip3_210_67405">
          <rect
            width="30"
            height="30"
            fill="white"
            transform="translate(376.539 50.8715) rotate(-169.427)"
          />
        </clipPath>
        <clipPath id="clip4_210_67405">
          <rect
            width="30"
            height="30"
            fill="white"
            transform="translate(374.921 124.737) rotate(110.976)"
          />
        </clipPath>
        <clipPath id="clip5_210_67405">
          <rect
            width="30"
            height="30"
            fill="white"
            transform="translate(364.888 168.225) rotate(40.5162)"
          />
        </clipPath>
        <clipPath id="clip6_210_67405">
          <rect
            width="30"
            height="30"
            fill="white"
            transform="translate(16.9856 210.162) rotate(62.6723)"
          />
        </clipPath>
        <clipPath id="clip7_210_67405">
          <rect
            width="30"
            height="30"
            fill="white"
            transform="translate(141.827 27.1539) rotate(117.95)"
          />
        </clipPath>
        <clipPath id="clip8_210_67405">
          <rect
            width="30"
            height="30"
            fill="white"
            transform="translate(321.555 29.4386) rotate(127.047)"
          />
        </clipPath>
        <clipPath id="clip9_210_67405">
          <rect
            width="30"
            height="30"
            fill="white"
            transform="translate(-10.6089 167.801) rotate(-40.7475)"
          />
        </clipPath>
        <clipPath id="clip10_210_67405">
          <rect
            width="30"
            height="30"
            fill="white"
            transform="translate(377.315 97.0226) rotate(-168.697)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default IntroStarsConfetti;
